module.exports = __webpack_public_path__ + "media/images/lp_v6_border2-8ee66f58fb78bbc2dec6cf1c8d380370.webp";